<form [formGroup]="configForm" (ngSubmit)="onSubmit()" #configFormRef="ngForm">
    <div class="modal-body">
        <div>
            <h4>Configuración de Cesión de Documentos</h4>
            <div class="mt-5 form-group position-relative mx-auto">
                <div class="row">
                    <label for="" class="col-3 label-control">Dias de Vencimiento</label>
                    <div class="col-9">
                        <input type="number" min="15" class="form-control" id="diasVencimiento"
                            formControlName="diasVencimiento" [attr.disabled]="detailMode?detailMode:null"
                            placeholder="ingrese dias de vencimiento" [ngClass]="{
                        'is-invalid':configFormRef.submitted && configForm.get('diasVencimiento').invalid
                    }">
                        <div *ngIf="configFormRef.submitted &&( configForm.get('diasVencimiento').invalid || configForm.get('diasVencimiento').dirty)"
                            class="invalid-feedback">
                            <div *ngIf="configForm.get('diasVencimiento').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" *ngIf="!detailMode">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">Guardar</span>
        </button>
        <button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>